import { render } from "./createproduct.vue?vue&type=template&id=d5d5a3a6&scoped=true"
import script from "./createproduct.vue?vue&type=script&lang=js"
export * from "./createproduct.vue?vue&type=script&lang=js"

import "./createproduct.vue?vue&type=style&index=0&id=d5d5a3a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d5a3a6"]])

export default __exports__